$(document).ready(function () {
    function activateBox(index) {
        $(".final-investment-box").removeClass("active").css("height", "");
        $(".final-investment-container  .final-investment-circle").removeClass("active");
        $(".final-investment-line").removeClass("active");
    
        const $activeBox = $(".final-investment-box").eq(index);
        $activeBox.addClass("active");
    
        const expandedHeight = $activeBox[0].scrollHeight; 
        //$activeBox.css("height", expandedHeight + "px");
    
        $('.final-investment-container .final-investment-circle[data-index="' + (index + 1) + '"]').addClass('active');
        $(".final-investment-line:lt(" + index + ")").addClass("active");
    }
    
    // activateBox(0);
    let currentIndex = 0;
    const totalItems = $(".final-investment-box").length; 

    //autoplay function
    function autoplay() {
        activateBox(currentIndex);
        currentIndex = (currentIndex + 1) % totalItems; 
    }

    autoplay();  
    setInterval(autoplay, 7000); 

    $(".final-investment-box").on("click", function () {
        const index = $(this).data("index") - 1;
        activateBox(index);
        currentIndex = index; 
    });

    $(".final-investment-circle").on("click", function () {
        const index = $(this).data("index") - 1;
        activateBox(index);
        currentIndex = index; 
    });
});


////////////////////////////////////For New Page sEction ////////////////////////////////////// 

$(document).ready(function() {
    const $modalOverlay = $('#modalOverlay');
    const $modalContent = $('#modalContent');
    const $closeModalButton = $('#closeModal');

    

    function openModal() {
        $modalOverlay.addClass('show');
        $modalContent.addClass('show');
    }

    function closeModal() {
        $modalOverlay.removeClass('show');
        $modalContent.removeClass('show');
    }

    $('.itemBox .video-box1').on('click', function() {
        const videoLink = $(this).data('video');
        if(videoLink){
            const videoPlayer = $('#videoPlayer');
            $('#modalContent .modal-inner video source').attr("src", videoLink);
            videoPlayer[0].load();
            openModal();
        }
    });

    $closeModalButton.on('click', function() {
        closeModal();
    });

    // Close the modal 
    $modalOverlay.on('click', function() {
        closeModal();
    });
});
